import axios from 'axios';

async function ObtenerPais(prmIdPais: number) {
    
    const url = "https://endpoints.mapsys.com.ar/gestion/obtener_pais"
    
    try {
        const response = await axios.post(url, {
            "usuario": "mpatti",
            "clave": "all2GetHer_!",
            "id_pais": prmIdPais
        });
        return response.data;
    } catch (error) {
        return error;
    }
};

export default ObtenerPais;